module.exports = "/images/ic-wave.png";